import { useBunja } from 'bunja/react';
import { useAtomValue, useSetAtom, useStore } from 'jotai';

import { Slider } from '@flipster/ui';
import segment from '@flipster/utils/segment';
import { TradeEvent } from '@flipster/utils/segment/events/trade';

import { PercentMarks } from '@web/constants/slider-marker';

import { formBunja } from './bunja/form';
import { formSegmentDataBunja } from './bunja/form-segment-data';
import { formItem } from './styles';

/**
 * 주문 비율 슬라이더. orderPercent(표시값)에만 의존하므로 슬라이더 위치가 바뀔 때만 리렌더된다.
 * 눈금(marks)은 모듈 상수라 정적이며, segment 페이로드 값은 store.get으로 읽어 구독을 늘리지 않는다.
 */
const OrderPercentSlider = () => {
  const store = useStore();
  const { orderPercentAtom, changeOrderPercentAtom } = useBunja(formBunja);
  const { symbol, orderByTokenAtom, orderTypeAtom, positionModeAtom } = useBunja(formSegmentDataBunja);

  const orderPercent = useAtomValue(orderPercentAtom);
  const changeOrderPercent = useSetAtom(changeOrderPercentAtom);

  return (
    <div className={formItem}>
      <Slider
        value={orderPercent}
        min={0}
        max={100}
        marks={PercentMarks}
        onChange={(percent) => changeOrderPercent(percent)}
        onFocus={() => {
          segment.track(TradeEvent.OrderAmountEditClick, {
            symbol: symbol,
            position_mode: store.get(positionModeAtom),
            order_by_token: store.get(orderByTokenAtom),
            order_type: store.get(orderTypeAtom),
            amount_input_type: 'slider',
          });
        }}
      />
    </div>
  );
};

export default OrderPercentSlider;
